import React from 'react';
import styles from './AuthorizationLayoutTablet.module.scss';
import Support from '../../../Features/Support/Support';
import Logo from '../../../Common/Logo/Logo';

function AuthorizationLayoutTablet(props: JSX.ElementChildrenAttribute) {
  const { children } = props;

  return (
    <div className={styles.page}>
      <div className={styles.top}>
        <Logo className={styles.logo} />
        <Support />
      </div>
      <div className={styles.container}>{children}</div>
    </div>
  );
}

export default AuthorizationLayoutTablet;
